import {r as W} from '@theme/theme-sections';
import {f as X} from '@theme/currency';
import {F as Y} from '@theme/flickity';
import {i as N} from '@theme/product-description';
import '@theme/_commonjsHelpers';
function k(i) {
  '@babel/helpers - typeof';
  return (
    (k =
      typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e && typeof Symbol == 'function' && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e;
          }),
    k(i)
  );
}
var q = (typeof HTMLElement > 'u' ? 'undefined' : k(HTMLElement)) === 'object';
function I(i) {
  return q
    ? i instanceof HTMLElement
    : i && k(i) === 'object' && i !== null && i.nodeType === 1 && typeof i.nodeName == 'string';
}
function B(i, e) {
  e.forEach(function (t) {
    i.classList.add(t);
  });
}
function S(i, e) {
  e.forEach(function (t) {
    i.classList.remove(t);
  });
}
var j =
  '.drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}';
function U() {
  if (!document.querySelector('.drift-base-styles')) {
    var i = document.createElement('style');
    (i.type = 'text/css'), i.classList.add('drift-base-styles'), i.appendChild(document.createTextNode(j));
    var e = document.head;
    e.insertBefore(i, e.firstChild);
  }
}
function _() {
  throw new Error('Missing parameter');
}
function Q(i, e) {
  if (!(i instanceof e)) throw new TypeError('Cannot call a class as a function');
}
function V(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      'value' in n && (n.writable = !0),
      Object.defineProperty(i, n.key, n);
  }
}
function G(i, e, t) {
  return V(i.prototype, e), Object.defineProperty(i, 'prototype', {writable: !1}), i;
}
var J = (function () {
  function i(e) {
    Q(this, i), (this.isShowing = !1);
    var t = e.namespace,
      n = t === void 0 ? null : t,
      s = e.zoomFactor,
      r = s === void 0 ? _() : s,
      d = e.containerEl,
      l = d === void 0 ? _() : d;
    (this.settings = {namespace: n, zoomFactor: r, containerEl: l}),
      (this.openClasses = this._buildClasses('open')),
      this._buildElement();
  }
  return (
    G(i, [
      {
        key: '_buildClasses',
        value: function (t) {
          var n = ['drift-'.concat(t)],
            s = this.settings.namespace;
          return s && n.push(''.concat(s, '-').concat(t)), n;
        },
      },
      {
        key: '_buildElement',
        value: function () {
          (this.el = document.createElement('div')), B(this.el, this._buildClasses('bounding-box'));
        },
      },
      {
        key: 'show',
        value: function (t, n) {
          (this.isShowing = !0), this.settings.containerEl.appendChild(this.el);
          var s = this.el.style;
          (s.width = ''.concat(Math.round(t / this.settings.zoomFactor), 'px')),
            (s.height = ''.concat(Math.round(n / this.settings.zoomFactor), 'px')),
            B(this.el, this.openClasses);
        },
      },
      {
        key: 'hide',
        value: function () {
          this.isShowing && this.settings.containerEl.removeChild(this.el),
            (this.isShowing = !1),
            S(this.el, this.openClasses);
        },
      },
      {
        key: 'setPosition',
        value: function (t, n, s) {
          var r = window.pageXOffset,
            d = window.pageYOffset,
            l = s.left + t * s.width - this.el.clientWidth / 2 + r,
            h = s.top + n * s.height - this.el.clientHeight / 2 + d;
          l < s.left + r
            ? (l = s.left + r)
            : l + this.el.clientWidth > s.left + s.width + r && (l = s.left + s.width - this.el.clientWidth + r),
            h < s.top + d
              ? (h = s.top + d)
              : h + this.el.clientHeight > s.top + s.height + d && (h = s.top + s.height - this.el.clientHeight + d),
            (this.el.style.left = ''.concat(l, 'px')),
            (this.el.style.top = ''.concat(h, 'px'));
        },
      },
    ]),
    i
  );
})();
function K(i, e) {
  if (!(i instanceof e)) throw new TypeError('Cannot call a class as a function');
}
function R(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      'value' in n && (n.writable = !0),
      Object.defineProperty(i, n.key, n);
  }
}
function ee(i, e, t) {
  return R(i.prototype, e), Object.defineProperty(i, 'prototype', {writable: !1}), i;
}
var te = (function () {
  function i() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    K(this, i),
      (this._show = this._show.bind(this)),
      (this._hide = this._hide.bind(this)),
      (this._handleEntry = this._handleEntry.bind(this)),
      (this._handleMovement = this._handleMovement.bind(this));
    var t = e.el,
      n = t === void 0 ? _() : t,
      s = e.zoomPane,
      r = s === void 0 ? _() : s,
      d = e.sourceAttribute,
      l = d === void 0 ? _() : d,
      h = e.handleTouch,
      c = h === void 0 ? _() : h,
      a = e.onShow,
      u = a === void 0 ? null : a,
      w = e.onHide,
      p = w === void 0 ? null : w,
      g = e.hoverDelay,
      b = g === void 0 ? 0 : g,
      o = e.touchDelay,
      y = o === void 0 ? 0 : o,
      m = e.hoverBoundingBox,
      f = m === void 0 ? _() : m,
      v = e.touchBoundingBox,
      C = v === void 0 ? _() : v,
      E = e.namespace,
      L = E === void 0 ? null : E,
      z = e.zoomFactor,
      P = z === void 0 ? _() : z,
      T = e.boundingBoxContainer,
      $ = T === void 0 ? _() : T,
      A = e.passive,
      Z = A === void 0 ? !1 : A;
    (this.settings = {
      el: n,
      zoomPane: r,
      sourceAttribute: l,
      handleTouch: c,
      onShow: u,
      onHide: p,
      hoverDelay: b,
      touchDelay: y,
      hoverBoundingBox: f,
      touchBoundingBox: C,
      namespace: L,
      zoomFactor: P,
      boundingBoxContainer: $,
      passive: Z,
    }),
      (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) &&
        (this.boundingBox = new J({
          namespace: this.settings.namespace,
          zoomFactor: this.settings.zoomFactor,
          containerEl: this.settings.boundingBoxContainer,
        })),
      (this.enabled = !0),
      this._bindEvents();
  }
  return (
    ee(i, [
      {
        key: '_preventDefault',
        value: function (t) {
          t.preventDefault();
        },
      },
      {
        key: '_preventDefaultAllowTouchScroll',
        value: function (t) {
          (!this.settings.touchDelay || !this._isTouchEvent(t) || this.isShowing) && t.preventDefault();
        },
      },
      {
        key: '_isTouchEvent',
        value: function (t) {
          return !!t.touches;
        },
      },
      {
        key: '_bindEvents',
        value: function () {
          this.settings.el.addEventListener('mouseenter', this._handleEntry),
            this.settings.el.addEventListener('mouseleave', this._hide),
            this.settings.el.addEventListener('mousemove', this._handleMovement);
          var t = {passive: this.settings.passive};
          this.settings.handleTouch
            ? (this.settings.el.addEventListener('touchstart', this._handleEntry, t),
              this.settings.el.addEventListener('touchend', this._hide),
              this.settings.el.addEventListener('touchmove', this._handleMovement, t))
            : (this.settings.el.addEventListener('touchstart', this._preventDefault, t),
              this.settings.el.addEventListener('touchend', this._preventDefault),
              this.settings.el.addEventListener('touchmove', this._preventDefault, t));
        },
      },
      {
        key: '_unbindEvents',
        value: function () {
          this.settings.el.removeEventListener('mouseenter', this._handleEntry),
            this.settings.el.removeEventListener('mouseleave', this._hide),
            this.settings.el.removeEventListener('mousemove', this._handleMovement),
            this.settings.handleTouch
              ? (this.settings.el.removeEventListener('touchstart', this._handleEntry),
                this.settings.el.removeEventListener('touchend', this._hide),
                this.settings.el.removeEventListener('touchmove', this._handleMovement))
              : (this.settings.el.removeEventListener('touchstart', this._preventDefault),
                this.settings.el.removeEventListener('touchend', this._preventDefault),
                this.settings.el.removeEventListener('touchmove', this._preventDefault));
        },
      },
      {
        key: '_handleEntry',
        value: function (t) {
          this._preventDefaultAllowTouchScroll(t),
            (this._lastMovement = t),
            t.type == 'mouseenter' && this.settings.hoverDelay
              ? (this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay))
              : this.settings.touchDelay
                ? (this.entryTimeout = setTimeout(this._show, this.settings.touchDelay))
                : this._show();
        },
      },
      {
        key: '_show',
        value: function () {
          if (this.enabled) {
            var t = this.settings.onShow;
            if (
              (t && typeof t == 'function' && t(),
              this.settings.zoomPane.show(
                this.settings.el.getAttribute(this.settings.sourceAttribute),
                this.settings.el.clientWidth,
                this.settings.el.clientHeight
              ),
              this._lastMovement)
            ) {
              var n = this._lastMovement.touches;
              ((n && this.settings.touchBoundingBox) || (!n && this.settings.hoverBoundingBox)) &&
                this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
            }
            this._handleMovement();
          }
        },
      },
      {
        key: '_hide',
        value: function (t) {
          t && this._preventDefaultAllowTouchScroll(t),
            (this._lastMovement = null),
            this.entryTimeout && clearTimeout(this.entryTimeout),
            this.boundingBox && this.boundingBox.hide();
          var n = this.settings.onHide;
          n && typeof n == 'function' && n(), this.settings.zoomPane.hide();
        },
      },
      {
        key: '_handleMovement',
        value: function (t) {
          if (t) this._preventDefaultAllowTouchScroll(t), (this._lastMovement = t);
          else if (this._lastMovement) t = this._lastMovement;
          else return;
          var n, s;
          if (t.touches) {
            var r = t.touches[0];
            (n = r.clientX), (s = r.clientY);
          } else (n = t.clientX), (s = t.clientY);
          var d = this.settings.el,
            l = d.getBoundingClientRect(),
            h = n - l.left,
            c = s - l.top,
            a = h / this.settings.el.clientWidth,
            u = c / this.settings.el.clientHeight;
          this.boundingBox && this.boundingBox.setPosition(a, u, l), this.settings.zoomPane.setPosition(a, u, l);
        },
      },
      {
        key: 'isShowing',
        get: function () {
          return this.settings.zoomPane.isShowing;
        },
      },
    ]),
    i
  );
})();
function ie(i, e) {
  if (!(i instanceof e)) throw new TypeError('Cannot call a class as a function');
}
function ne(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      'value' in n && (n.writable = !0),
      Object.defineProperty(i, n.key, n);
  }
}
function se(i, e, t) {
  return ne(i.prototype, e), Object.defineProperty(i, 'prototype', {writable: !1}), i;
}
var oe = (function () {
  function i() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if ((ie(this, i), (this.HAS_ANIMATION = !1), typeof document < 'u')) {
      var t = document.createElement('div').style;
      this.HAS_ANIMATION = 'animation' in t || 'webkitAnimation' in t;
    }
    (this._completeShow = this._completeShow.bind(this)),
      (this._completeHide = this._completeHide.bind(this)),
      (this._handleLoad = this._handleLoad.bind(this)),
      (this.isShowing = !1);
    var n = e.container,
      s = n === void 0 ? null : n,
      r = e.zoomFactor,
      d = r === void 0 ? _() : r,
      l = e.inline,
      h = l === void 0 ? _() : l,
      c = e.namespace,
      a = c === void 0 ? null : c,
      u = e.showWhitespaceAtEdges,
      w = u === void 0 ? _() : u,
      p = e.containInline,
      g = p === void 0 ? _() : p,
      b = e.inlineOffsetX,
      o = b === void 0 ? 0 : b,
      y = e.inlineOffsetY,
      m = y === void 0 ? 0 : y,
      f = e.inlineContainer,
      v = f === void 0 ? document.body : f;
    (this.settings = {
      container: s,
      zoomFactor: d,
      inline: h,
      namespace: a,
      showWhitespaceAtEdges: w,
      containInline: g,
      inlineOffsetX: o,
      inlineOffsetY: m,
      inlineContainer: v,
    }),
      (this.openClasses = this._buildClasses('open')),
      (this.openingClasses = this._buildClasses('opening')),
      (this.closingClasses = this._buildClasses('closing')),
      (this.inlineClasses = this._buildClasses('inline')),
      (this.loadingClasses = this._buildClasses('loading')),
      this._buildElement();
  }
  return (
    se(i, [
      {
        key: '_buildClasses',
        value: function (t) {
          var n = ['drift-'.concat(t)],
            s = this.settings.namespace;
          return s && n.push(''.concat(s, '-').concat(t)), n;
        },
      },
      {
        key: '_buildElement',
        value: function () {
          (this.el = document.createElement('div')), B(this.el, this._buildClasses('zoom-pane'));
          var t = document.createElement('div');
          B(t, this._buildClasses('zoom-pane-loader')),
            this.el.appendChild(t),
            (this.imgEl = document.createElement('img')),
            this.el.appendChild(this.imgEl);
        },
      },
      {
        key: '_setImageURL',
        value: function (t) {
          this.imgEl.setAttribute('src', t);
        },
      },
      {
        key: '_setImageSize',
        value: function (t, n) {
          (this.imgEl.style.width = ''.concat(t * this.settings.zoomFactor, 'px')),
            (this.imgEl.style.height = ''.concat(n * this.settings.zoomFactor, 'px'));
        },
      },
      {
        key: 'setPosition',
        value: function (t, n, s) {
          var r = this.imgEl.offsetWidth,
            d = this.imgEl.offsetHeight,
            l = this.el.offsetWidth,
            h = this.el.offsetHeight,
            c = l / 2,
            a = h / 2,
            u = r * t,
            w = d * n,
            p = c - u,
            g = a - w,
            b = l - r,
            o = h - d,
            y = b > 0,
            m = o > 0,
            f = y ? b / 2 : 0,
            v = m ? o / 2 : 0,
            C = y ? b / 2 : b,
            E = m ? o / 2 : o;
          if (this.el.parentElement === this.settings.inlineContainer) {
            var L = window.pageXOffset,
              z = window.pageYOffset,
              P = s.left + t * s.width - l / 2 + this.settings.inlineOffsetX + L,
              T = s.top + n * s.height - h / 2 + this.settings.inlineOffsetY + z;
            this.settings.containInline &&
              (P < s.left + L ? (P = s.left + L) : P + l > s.left + s.width + L && (P = s.left + s.width - l + L),
              T < s.top + z ? (T = s.top + z) : T + h > s.top + s.height + z && (T = s.top + s.height - h + z)),
              (this.el.style.left = ''.concat(P, 'px')),
              (this.el.style.top = ''.concat(T, 'px'));
          }
          this.settings.showWhitespaceAtEdges ||
            (p > f ? (p = f) : p < C && (p = C), g > v ? (g = v) : g < E && (g = E)),
            (this.imgEl.style.transform = 'translate('.concat(p, 'px, ').concat(g, 'px)')),
            (this.imgEl.style.webkitTransform = 'translate('.concat(p, 'px, ').concat(g, 'px)'));
        },
      },
      {
        key: '_removeListenersAndResetClasses',
        value: function () {
          this.el.removeEventListener('animationend', this._completeShow),
            this.el.removeEventListener('animationend', this._completeHide),
            this.el.removeEventListener('webkitAnimationEnd', this._completeShow),
            this.el.removeEventListener('webkitAnimationEnd', this._completeHide),
            S(this.el, this.openClasses),
            S(this.el, this.closingClasses);
        },
      },
      {
        key: 'show',
        value: function (t, n, s) {
          this._removeListenersAndResetClasses(),
            (this.isShowing = !0),
            B(this.el, this.openClasses),
            this.imgEl.getAttribute('src') != t &&
              (B(this.el, this.loadingClasses),
              this.imgEl.addEventListener('load', this._handleLoad),
              this._setImageURL(t)),
            this._setImageSize(n, s),
            this._isInline ? this._showInline() : this._showInContainer(),
            this.HAS_ANIMATION &&
              (this.el.addEventListener('animationend', this._completeShow),
              this.el.addEventListener('webkitAnimationEnd', this._completeShow),
              B(this.el, this.openingClasses));
        },
      },
      {
        key: '_showInline',
        value: function () {
          this.settings.inlineContainer.appendChild(this.el), B(this.el, this.inlineClasses);
        },
      },
      {
        key: '_showInContainer',
        value: function () {
          this.settings.container.appendChild(this.el);
        },
      },
      {
        key: 'hide',
        value: function () {
          this._removeListenersAndResetClasses(),
            (this.isShowing = !1),
            this.HAS_ANIMATION
              ? (this.el.addEventListener('animationend', this._completeHide),
                this.el.addEventListener('webkitAnimationEnd', this._completeHide),
                B(this.el, this.closingClasses))
              : (S(this.el, this.openClasses), S(this.el, this.inlineClasses));
        },
      },
      {
        key: '_completeShow',
        value: function () {
          this.el.removeEventListener('animationend', this._completeShow),
            this.el.removeEventListener('webkitAnimationEnd', this._completeShow),
            S(this.el, this.openingClasses);
        },
      },
      {
        key: '_completeHide',
        value: function () {
          this.el.removeEventListener('animationend', this._completeHide),
            this.el.removeEventListener('webkitAnimationEnd', this._completeHide),
            S(this.el, this.openClasses),
            S(this.el, this.closingClasses),
            S(this.el, this.inlineClasses),
            (this.el.style.left = ''),
            (this.el.style.top = ''),
            this.el.parentElement === this.settings.container
              ? this.settings.container.removeChild(this.el)
              : this.el.parentElement === this.settings.inlineContainer &&
                this.settings.inlineContainer.removeChild(this.el);
        },
      },
      {
        key: '_handleLoad',
        value: function () {
          this.imgEl.removeEventListener('load', this._handleLoad), S(this.el, this.loadingClasses);
        },
      },
      {
        key: '_isInline',
        get: function () {
          var t = this.settings.inline;
          return t === !0 || (typeof t == 'number' && window.innerWidth <= t);
        },
      },
    ]),
    i
  );
})();
function ae(i, e) {
  if (!(i instanceof e)) throw new TypeError('Cannot call a class as a function');
}
function le(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      'value' in n && (n.writable = !0),
      Object.defineProperty(i, n.key, n);
  }
}
function he(i, e, t) {
  return le(i.prototype, e), Object.defineProperty(i, 'prototype', {writable: !1}), i;
}
var x = (function () {
  function i(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (
      (ae(this, i),
      (this.VERSION = '1.5.1'),
      (this.triggerEl = e),
      (this.destroy = this.destroy.bind(this)),
      !I(this.triggerEl))
    )
      throw new TypeError('`new Drift` requires a DOM element as its first argument.');
    var n = t.namespace || null,
      s = t.showWhitespaceAtEdges || !1,
      r = t.containInline || !1,
      d = t.inlineOffsetX || 0,
      l = t.inlineOffsetY || 0,
      h = t.inlineContainer || document.body,
      c = t.sourceAttribute || 'data-zoom',
      a = t.zoomFactor || 3,
      u = t.paneContainer === void 0 ? document.body : t.paneContainer,
      w = t.inlinePane || 375,
      p = 'handleTouch' in t ? !!t.handleTouch : !0,
      g = t.onShow || null,
      b = t.onHide || null,
      o = 'injectBaseStyles' in t ? !!t.injectBaseStyles : !0,
      y = t.hoverDelay || 0,
      m = t.touchDelay || 0,
      f = t.hoverBoundingBox || !1,
      v = t.touchBoundingBox || !1,
      C = t.boundingBoxContainer || document.body,
      E = t.passive || !1;
    if (w !== !0 && !I(u)) throw new TypeError('`paneContainer` must be a DOM element when `inlinePane !== true`');
    if (!I(h)) throw new TypeError('`inlineContainer` must be a DOM element');
    (this.settings = {
      namespace: n,
      showWhitespaceAtEdges: s,
      containInline: r,
      inlineOffsetX: d,
      inlineOffsetY: l,
      inlineContainer: h,
      sourceAttribute: c,
      zoomFactor: a,
      paneContainer: u,
      inlinePane: w,
      handleTouch: p,
      onShow: g,
      onHide: b,
      injectBaseStyles: o,
      hoverDelay: y,
      touchDelay: m,
      hoverBoundingBox: f,
      touchBoundingBox: v,
      boundingBoxContainer: C,
      passive: E,
    }),
      this.settings.injectBaseStyles && U(),
      this._buildZoomPane(),
      this._buildTrigger();
  }
  return (
    he(i, [
      {
        key: '_buildZoomPane',
        value: function () {
          this.zoomPane = new oe({
            container: this.settings.paneContainer,
            zoomFactor: this.settings.zoomFactor,
            showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
            containInline: this.settings.containInline,
            inline: this.settings.inlinePane,
            namespace: this.settings.namespace,
            inlineOffsetX: this.settings.inlineOffsetX,
            inlineOffsetY: this.settings.inlineOffsetY,
            inlineContainer: this.settings.inlineContainer,
          });
        },
      },
      {
        key: '_buildTrigger',
        value: function () {
          this.trigger = new te({
            el: this.triggerEl,
            zoomPane: this.zoomPane,
            handleTouch: this.settings.handleTouch,
            onShow: this.settings.onShow,
            onHide: this.settings.onHide,
            sourceAttribute: this.settings.sourceAttribute,
            hoverDelay: this.settings.hoverDelay,
            touchDelay: this.settings.touchDelay,
            hoverBoundingBox: this.settings.hoverBoundingBox,
            touchBoundingBox: this.settings.touchBoundingBox,
            namespace: this.settings.namespace,
            zoomFactor: this.settings.zoomFactor,
            boundingBoxContainer: this.settings.boundingBoxContainer,
            passive: this.settings.passive,
          });
        },
      },
      {
        key: 'setZoomImageURL',
        value: function (t) {
          this.zoomPane._setImageURL(t);
        },
      },
      {
        key: 'disable',
        value: function () {
          this.trigger.enabled = !1;
        },
      },
      {
        key: 'enable',
        value: function () {
          this.trigger.enabled = !0;
        },
      },
      {
        key: 'destroy',
        value: function () {
          this.trigger._hide(), this.trigger._unbindEvents();
        },
      },
      {
        key: 'isShowing',
        get: function () {
          return this.zoomPane.isShowing;
        },
      },
      {
        key: 'zoomFactor',
        get: function () {
          return this.settings.zoomFactor;
        },
        set: function (t) {
          (this.settings.zoomFactor = t),
            (this.zoomPane.settings.zoomFactor = t),
            (this.trigger.settings.zoomFactor = t),
            (this.boundingBox.settings.zoomFactor = t);
        },
      },
    ]),
    i
  );
})();
Object.defineProperty(x.prototype, 'isShowing', {
  get: function () {
    return this.isShowing;
  },
});
Object.defineProperty(x.prototype, 'zoomFactor', {
  get: function () {
    return this.zoomFactor;
  },
  set: function (e) {
    this.zoomFactor = e;
  },
});
x.prototype.setZoomImageURL = x.prototype.setZoomImageURL;
x.prototype.disable = x.prototype.disable;
x.prototype.enable = x.prototype.enable;
x.prototype.destroy = x.prototype.destroy;
const D = {productForm: 'form', slider: '[data-product-media-slider]'},
  F = 'main-product';
var M, O, H;
const re =
    ((H = (O = (M = window.Shopify) == null ? void 0 : M.theme) == null ? void 0 : O.sections) == null
      ? void 0
      : H.registered) || {},
  de = typeof re[F] > 'u';
de &&
  W(F, {
    onLoad() {
      (this.slider = null),
        (this.productZooms = []),
        (this.sliderImages = this.container.querySelectorAll('[data-slide]')),
        (this.productForm = this.container.querySelector(D.productForm)),
        (this.tabletQuery = window.matchMedia(`(min-width: ${window.theme.breakpoints.md}px) and (hover: hover) and (pointer: fine)`)),
        N(),
        this.initProductMediaSlider(),
        this.initProductMediaProgress(),
        this.initResponsiveZoom(),
        this.handleVariantChange();
    },
    initResponsiveZoom() {
      this.tabletQuery.matches && this.initZoom();
      this.handleTabletQueryChange = (i) => {
        if (i.matches) this.initZoom();
        else {
          this.productZooms.forEach((e) => e.destroy());
          this.productZooms = [];
        }
      };
      this.tabletQuery.addEventListener('change', this.handleTabletQueryChange);
    },
    initZoom() {
      this.sliderImages.length > 0 &&
        this.sliderImages.forEach((i) => {
          const e = i.querySelector('img');
          if (!e || !e.dataset.zoom) return;
          const t = new x(e, {paneContainer: e.parentNode, inlinePane: !1, zoomFactor: 2});
          this.productZooms.push(t);
        });
    },
    handleVariantChange() {
      const i = this.productForm.querySelector('input[name="id"]');
      i &&
        i.addEventListener('variant_update', (e) => {
          var n;
          const t = (n = e.detail) == null ? void 0 : n.variant;
          t && (this.updateProductMedia(t), this.updateInstalmentsEstimate(t));
        });
    },
    updateInstalmentsEstimate(i) {
      var c;
      const e = this.container.querySelector('[data-instalment-estimate]');
      if (!e) return;
      const t = Number(e.dataset.instalmentCount),
        n = Number(i.price);
      if (!Number.isFinite(t) || t <= 0 || !Number.isFinite(n)) return;
      const s = (c = e.dataset.discountType) == null ? void 0 : c.trim().toLowerCase(),
        r = Number(e.dataset.discountValue);
      let d = n;
      Number.isFinite(r) &&
        r >= 0 &&
        (s === 'percentage'
          ? (d = Math.max(0, n * ((100 - r) / 100)))
          : s === 'fixed' && (d = Math.max(0, n - r * 100)));
      const l = window.theme.moneyFormat,
        h = e.hasAttribute('data-secret-sale-instalment') ? Math.floor(Math.floor(d) / t) : d / t;
      e.innerHTML = X(h, l);
    },
    updateProductMedia(i) {
      var h, c;
      const {colorOptionIndex: e} = this.container.dataset,
        t = (h = i.options[e]) == null ? void 0 : h.toLowerCase();
      this.container.querySelectorAll('[data-slide][data-color]').forEach((a) => {
        const {color: u} = a.dataset;
        u === t
          ? a.classList.remove('main-product__media-slide--hidden')
          : a.classList.add('main-product__media-slide--hidden');
      }),
        this.slider && this.slider.reloadCells();
      this.updateProductMediaProgress();
      const s = i.featured_media,
        r = s
          ? this.container.querySelector(`[data-media-id="${s.id}"]`)
          : this.container.querySelector(`[data-slide][data-color="${t}"]`);
      if (!r || window.matchMedia('(max-width: 989px)').matches) return;
      const l = ((c = document.querySelector('[data-section-id="header"]')) == null ? void 0 : c.offsetHeight) || 0;
      window.scrollTo({top: r.offsetTop - l, behavior: 'smooth'});
    },
    initProductMediaProgress() {
      this.mediaProgress = this.container.querySelector('[data-product-media-progress]');
      if (!this.slider || !this.mediaProgress) return;
      this.handleMediaProgress = () => this.updateProductMediaProgress();
      // Flickity deactivates and removes these listeners when the section unloads.
      for (const event of ['select', 'resize', 'activate', 'deactivate']) {
        this.slider.on(event, this.handleMediaProgress);
      }
      this.updateProductMediaProgress();
    },
    updateProductMediaProgress() {
      if (!this.mediaProgress || !this.slider) return;
      const visible = [...this.sliderImages].filter(image => !image.classList.contains('main-product__media-slide--hidden'));
      const count = visible.length;
      let index = visible.indexOf(this.slider.selectedElement);
      // Flickity can select a zero-width, colour-filtered cell at either end.
      // Its contained target still identifies the visible image at that position.
      if (index < 0 && this.slider.selectedSlide) {
        let nearest = Infinity;
        visible.forEach((image, candidate) => {
          const slide = this.slider.slides.find(slide => slide.cells.some(cell => cell.element === image));
          const distance = Math.abs((slide?.target ?? Infinity) - this.slider.selectedSlide.target);
          if (distance < nearest) {
            nearest = distance;
            index = candidate;
          }
        });
      }
      this.mediaProgress.hidden = !this.slider.isActive || count < 2;
      this.mediaProgress.style.setProperty('--gallery-count', String(Math.max(1, count)));
      this.mediaProgress.style.setProperty('--gallery-index', String(Math.max(0, index)));
    },
    initProductMediaSlider() {
      const i = this.container.querySelector(D.slider);
      if (!i) return;
      this.slider = new Y(i, {
        prevNextButtons: !1,
        pageDots: !1,
        cellAlign: 'left',
        contain: !0,
        watchCSS: !0,
        draggable: !0,
        wrapAround: !1,
      });
      this.allowBrowserPinchZoom();
    },
    allowBrowserPinchZoom() {
      const slider = this.slider;
      const touchStart = slider.ontouchstart;
      const touchMove = slider.ontouchmove;
      let browserGesture = false;
      let releaseTimer;
      const handleTouch = (event, original) => {
        if (event.touches.length > 1 && !browserGesture) {
          browserGesture = true;
          clearTimeout(releaseTimer);
          // Hand two fingers to the browser without cancelling its default gesture.
          // Also release a one-finger drag that was already in progress.
          slider._pointerDone();
          slider.isDragging = false;
          slider.isPreventingClicks = true;
          slider.viewport.classList.remove('is-pointer-down');
          slider.select(slider.selectedIndex, false, true);
        }
        if (!browserGesture) original.call(slider, event);
      };
      slider.ontouchstart = (event) => handleTouch(event, touchStart);
      slider.ontouchmove = (event) => handleTouch(event, touchMove);
      const release = (event) => {
        if (!browserGesture || event.touches.length) return;
        browserGesture = false;
        releaseTimer = setTimeout(() => { delete slider.isPreventingClicks; }, 0);
      };
      window.addEventListener('touchend', release, {passive: true});
      window.addEventListener('touchcancel', release, {passive: true});
      this.cleanupBrowserPinchZoom = () => {
        clearTimeout(releaseTimer);
        window.removeEventListener('touchend', release);
        window.removeEventListener('touchcancel', release);
        slider.ontouchstart = touchStart;
        slider.ontouchmove = touchMove;
      };
    },
    onUnload() {
      var i;
      this.cleanupBrowserPinchZoom?.();
      // A queued watchCSS resize can reactivate Flickity after destroy.
      clearTimeout(this.slider?.onresizeTimeout);
      this.productZooms && (this.productZooms.forEach((e) => e.destroy()), (this.productZooms = [])),
        (i = this.slider) == null || i.destroy(),
        (this.slider = null),
        this.tabletQuery &&
          this.handleTabletQueryChange &&
          this.tabletQuery.removeEventListener('change', this.handleTabletQueryChange);
    },
  });
